// ==================================================
// GSAP Global Setup
// ==================================================

// garante que o GSAP foi carregado via CDN
if (typeof window.gsap === 'undefined') {
  console.warn(
    '⚠️ GSAP não encontrado. Certifique-se de carregar o CDN antes deste arquivo.'
  )
} else {
  // plugin de scroll
  if (typeof window.ScrollTrigger !== 'undefined') {
    // evita registro duplicado
    if (!gsap.core.globals().ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger)
    }
  } else {
    console.warn(
      '⚠️ ScrollTrigger não encontrado. Adicione o script do plugin no HTML antes deste arquivo.'
    )
  }

  // ✅ configurações globais opcionais
  gsap.config({
    nullTargetWarn: false, // evita warnings se um seletor não existir
  })

  // ✅ valores padrão para animações (pode ajustar)
  gsap.defaults({
    ease: 'power2.out',
    duration: 0.8,
  })

  // ✅ ativa suavização de lag (melhora o scroll)
  gsap.ticker.lagSmoothing(1000, 16)

  console.info('✅ GSAP configurado globalmente.')
}
